import { useMusicConsent } from "@/application/usecases/useMusicConsent";
import { Button } from "@/presentation/components/Button";
import { Modal } from "@/presentation/components/overlay/Modal";
import "./MusicConsentOverlay.css";

const TITLE_ID = "music-consent-overlay-title";

/**
 * 囃子（BGM）・師範代の声を鳴らすかの確認（ユーザー指示）。
 * 初回と、最終操作から約30分経過後に再表示する。
 * Esc / 背景クリックは「鳴らさない」と同じ扱い（驚かせない既定）。
 */
export function MusicConsentOverlay() {
  const { open, accept, decline } = useMusicConsent();

  return (
    <Modal open={open} onClose={decline} titleId={TITLE_ID}>
      <h2 id={TITLE_ID} className="music-consent-overlay__title">
        音楽を鳴らしますか？
      </h2>
      <p className="music-consent-overlay__body">
        囃子と師範代の声です。あとから帳（設定）でも変えられます。しばらく操作がないと、もう一度うかがいます。
      </p>
      <div className="music-consent-overlay__actions">
        <Button variant="primary" onClick={accept}>
          鳴らす
        </Button>
        <Button variant="quiet" onClick={decline}>
          鳴らさない
        </Button>
      </div>
    </Modal>
  );
}
